<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.suas_user_username="{ header, item }">
      <router-link
        :to="header.getRoute(item)"
        v-text="item.suas_user_username"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/UsersActions/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTableUsersActions',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
